import { IFilter } from '../../types/filters';
import { ConstructionYearContainer } from '../../containers/advancedFilters/ConstructionYearContainer';

export const constructionYear: IFilter = {
  component: ConstructionYearContainer,
};
